<div *ngIf="(selectedConfig.isOlderVersion)" class="ngx-dropdown-container" tabindex="0">
    <button type="button" class="ngx-dropdown-button" [ngClass]="{'disabled':disabled}" [attr.data-testid]="'btn-ngx-dropdown-'+dataTestId" [disabled]="disabled" (click)="toggleSelectDropdown()">
        <span>{{selectedDisplayText.length>0?selectedDisplayText:selectedConfig.placeholder}} </span>
        <span class="nsdicon-angle-down"></span>
    </button>
    <div class="ngx-dropdown-list-container" *ngIf="toggleDropdown" [style.maxHeight]="selectedConfig.height">
        <div class="search-container" *ngIf="selectedConfig.search">
            <input #searchBox name="search" [(ngModel)]="searchText" />
            <label [ngClass]="{'active': searchText}">
                <span class="nsdicon-search"></span> {{selectedConfig.searchPlaceholder}}
            </label>
        </div>



        <span *ngIf="selectedItems.length > 0" class="clear-all"><input class="btn-primary" (click)="clearAll()" type="button" value="Clear All" /></span>
        <ul class="selected-items">

            <li tabindex="-1" *ngFor="let selected of selectedItems;let i = index" (click)="deselectItem(selected,i)">
                <span class="nsdicon-close"></span>
                <span> {{selected[selectedConfig.displayKey??'text'] || selected}}</span>
            </li>
        </ul>
        <hr *ngIf="selectedItems.length > 0 && availableItems.length > 0" />
        <ul class="available-items">
            <li #availableOption *ngFor="let item of availableItems| filterBy: searchText : selectedConfig?.searchOnKey | limitTo : selectedConfig?.limitTo??0;let i = index"
                tabindex="-1" [ngClass]="{'active': focusedItemIndex === i}" (click)="selectItem(item,i)">
                {{item[selectedConfig.displayKey??'text'] || item}}
            </li>
            <li *ngIf="showNotFound">{{selectedConfig.noResultsFound}}</li>
        </ul>
    </div>
</div>



<div *ngIf="(!selectedConfig.isOlderVersion)" class="ngx-dropdown-container {{customClass}}" [attr.data-testid]="'main-container-' + dataTestId">
  <input [ngClass]="[valdationClasss,disabled?'disabled':'']" [attr.data-testid]="'txt-value-' + dataTestId" [disabled]="disabled" #searchBox autocomplete="off" tabindex="{{tabindex}}" type="text" class="form-control" attr.name="name_{{customClass}}" [(ngModel)]="selectedDisplayText" placeholder="{{selectedConfig.placeholder}}" />
  <svg *ngIf="(selectedItems && selectedItems.length > 0 || selectedDisplayText.length > 0) && !isDataLoading  && !disabled" [attr.data-testid]="'btn-clear-' + dataTestId" class="svg-icon" (click)="clearAll()">
    <use xlink:href="assets/NewJT7/img/sprite.svg#button-close"></use>
  </svg>
  <span *ngIf="(selectedItems && selectedItems.length <= 0 && selectedDisplayText.length <= 0 && !isDataLoading && !disabled)" [attr.data-testid]="'btn-open-' + dataTestId" class="dropdown-search-icon">
    <app-svg-icon [type]="'Search'" [className]="'icon'" (click)="openDropDown()"></app-svg-icon>
  </span>
  <!--<svg *ngIf="(selectedItems && selectedItems.length <= 0 && selectedDisplayText.length <= 0 && !isDataLoading )" class="svg-icon" >
    <use xlink:href="assets/NewJT7/img/sprite.svg#Search"></use>
  </svg>-->
  <svg *ngIf="isDataLoading" class="loader-image" id="loader-1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40">
    <path opacity="0.2" d="M20.201,5.169c-8.254,0-14.946,6.692-14.946,14.946c0,8.255,6.692,14.946,14.946,14.946 s14.946-6.691,14.946-14.946C35.146,11.861,28.455,5.169,20.201,5.169z M20.201,31.749c-6.425,0-11.634-5.208-11.634-11.634 c0-6.425,5.209-11.634,11.634-11.634c6.425,0,11.633,5.209,11.633,11.634C31.834,26.541,26.626,31.749,20.201,31.749z" />
    <path d="M26.013,10.047l1.654-2.866c-2.198-1.272-4.743-2.012-7.466-2.012h0v3.312h0 C22.32,8.481,24.301,9.057,26.013,10.047z">
      <animateTransform attributeType="xml"
                        attributeName="transform"
                        type="rotate"
                        from="0 20 20"
                        to="360 20 20"
                        dur="1s"
                        repeatCount="indefinite" />
    </path>
  </svg>
  <!-- *ngIf="toggleDropdown" -->
  <div class="ngx-dropdown-list-container" *ngIf="toggleDropdown" [style.maxHeight]="selectedConfig.height" infiniteScroll
       [infiniteScrollDistance]="2"
       [infiniteScrollThrottle]="50"
       [scrollWindow]="false"
       (scrolled)="onScrollDown()"
       [attr.data-testid]="'options-container-' + dataTestId">

    <div [attr.data-testid]="'multi-configuration-container-' + dataTestId" *ngIf="configList && configList.length > 0" class="button-list ngx-multi-configuration-container">
      <button *ngFor="let config of configList"
              [attr.data-testid]="'button-' + config.buttonKey"
              (click)="changeActiveConfiguration(config)"
              class="btn btn-outline-primary mt-2"
              [ngClass]="{'active': config.isActive}"
              [disabled]="config.isActive"
              [attr.title]="config.buttonLabel"
              [attr.aria-label]="'button ' + config.buttonLabel">
        {{ config.buttonLabel }}
      </button>
      <hr />
    </div>

    <ng-container *ngIf="multiple">
      <div class="info-selected-bar" *ngIf="toggleDropdown">
        <span *ngIf="selectedItems && selectedItems.length > 0" [attr.data-testid]="'span-selected-count-' + dataTestId" class="selected-count">Selected: {{selectedCount}}</span>
        <span *ngIf="selectedItems && selectedItems.length > 0" [attr.data-testid]="'btn-clear-' + dataTestId" class="clear-all"><input class="btn-primary" (click)="clearAll()" type="button" value="Clear All" /></span>
      </div>
      <ul class="selected-items" [attr.data-testid]="'selected-options-container-' + dataTestId">

        <li tabindex="-1" *ngFor="let selected of selectedItems;let i = index" (click)="deselectItem(selected,i)">
          <span class="nsdicon-close"></span>
          <span> {{selected[selectedConfig.displayKey??'text'] || selected}}</span>
        </li>
      </ul>
      <hr *ngIf="selectedItems && selectedItems.length > 0 && filterdtems.length > 0" />
    </ng-container>
    <ul class="available-items draw-option" [attr.data-testid]="'available-options-container-' + dataTestId">
      <li #availableOption *ngFor="let item of filterdtems;let i = index"
          tabindex="-1" [ngClass]="{'hide': item['archived'] === 1,'active': focusedItemIndex === i}" (click)="selectItem(item,i)">
        {{item[selectedConfig.displayKey??'text'] || item}}
        <br /> <small *ngIf="selectedConfig.isSubTitle"><strong> {{item[selectedConfig.subTitleDisplayKey??'text'] || item}}</strong></small>
      </li>
      <li *ngIf="showNotFound" [attr.data-testid]="'li-no-result-found-' + dataTestId">{{selectedConfig.noResultsFound}}</li>
    </ul>
  </div>
</div>


